import './CoralBlogCards.scss'

import { CoralCardsSlider } from '@websrc/App/Components/CoralCardsSlider/CoralCardsSlider'
import { useFormattedDate } from '@websrc/App/Hooks/useFormatDate'
import { CoralMasterCardVisuals } from '@websrc/DataMappers/mapCoralMasterCard'
import { mapCoralWebBlogCards } from '@websrc/DataMappers/mapSpot'
import React, { FC, useEffect, useState } from 'react'

import { CoralMasterCard } from '../../../coral-library/cards/Coral/ContentCard/CoralMasterCard'

type CoralBlogCardsProps = ReturnType<typeof mapCoralWebBlogCards>

const visuals: CoralMasterCardVisuals = {
  headlineSize: 'label-lg-medium',
  bodySize: 'body-md',
  contentContainerColor: 'off-white',
  contentPadding: '3xl',
  imageOrientation: 'top',
  equalSize: false,
  imageRatio: '3-4',
  paddingHeadline: '2xl',
  paddingBody: 'sm',
  maxBodyLines: 2,
  buttonSize: 'md',
  radius: 4,
}

export const CardWrapper = ({ card }: { card: any }) => {
  const [isMounted, setIsMounted] = useState(false)

  useEffect(() => {
    setIsMounted(true)
  }, [])
  const formattedDate = useFormattedDate(isMounted ? card.body : undefined)
  return <CoralMasterCard visuals={visuals} {...card} body={formattedDate} />
}

export const CoralBlogCards: FC<CoralBlogCardsProps> = (props) => {
  return (
    <div className={'category-coral-spot'}>
      <div className={'coral-blog-cards'}>
        <CoralCardsSlider forceRow={true}>
          {props.eventCards.map((card, index) => {
            return <CardWrapper card={card} key={index} />
          })}
        </CoralCardsSlider>
      </div>
    </div>
  )
}
